import superagent from 'superagent';
import webservice from './webservice';
//import getCookie from './getCookie';

export default async function getVideos() {
  let response = {};

  await superagent
    .get(`${webservice}/getVideos`)
    .set('Content-Type', 'application/json')
    .then((res) => {
      response = res?.body || {};
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
